import React, { useState } from 'react';
import { Button, Spin,Checkbox, Form, Input } from 'antd';
import MainLayout from '../../components/layout/MainLayout';
import useAuth from '../../hooks/useAuth';
import { useRef } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addAdmin } from '../../store/adminSlice';
import AdmnNav from '../../components/Navbars/AdmnNav';
import { LoadingOutlined,UserOutlined, LockOutlined } from '@ant-design/icons';
import { useJwt } from 'react-jwt';
import fetchUserallowedRoutes from '../../hooks/fetchUserallowedRoutes';
import {app} from "../../config"
function OrgSignIn() {
  const styles = {
    container: {
      backgroundImage: `url("/bgimg.png")`,
      backgroundPosition: '50% 10%',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      width: '100vw',
      height: '100vh',
    },
  };
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );
  const dispatch = useDispatch();
  const [fieldsrequired, setFieldsRequired] = useState(false);
  const [success,setSuccess]=useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/organization/dashboard';
  window.document.title = 'Organization Sign In';
  let email;
  let password;

  const postData = async () => {
    console.log("function called");
    const userEmail=email;
    const userPassword = password;
    console.log(userEmail, userPassword);
    if (!(userEmail && userPassword)) {
      setFieldsRequired(true);
    } else if (userEmail && userPassword) {
      setFieldsRequired(false);
      try {
        let res = await axios.post(`${app.URL}/user/signin`, {
          email: userEmail,
          password: userPassword,
          userType: "O"
        });
        console.log(res.data.data);
        if(res.data.data.isActive&&res.data.data.userType==="O"){
        dispatch(addAdmin(res.data.data));
        localStorage.setItem('user', JSON.stringify(res.data.data));
        navigate(from , { replace: true });
        }
        else throw("You are not allowed here")
      } catch (err) {
        console.log(err);
        setSuccess(false)
        err.response?console.log(err.response.data.message):console.log('Error');
        if (typeof err === 'string') setErrorMsg(err);
        else if (typeof err === 'object') setErrorMsg(err.response.data.message);
      }
    }
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    email=values.email;
    password=values.password;
    console.log(email,password)
    setSuccess(true)
    postData();
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  // const keyPress = (e) => {
  //   if (e.key === 'Enter') postData();
  // };
  // document.addEventListener('keydown', keyPress);

  return (

    //   <>
  //  <>
  //   <div class='bg-white w-100'>
  //     <div class='row'>
  //       <AdmnNav />
  //     </div>
  //     <div class='row'>
  //       <div class='col-lg-7 col-md-6 col-sm-11 '>
  //         {/* <img src='./login.jpg' style={{ height: '57px', padding: '3px' }} alt=' Image' /> */}
  //         <img src='/login.jpg' class="ml-10 mt-12" style={{width:"700px"}} />
  //       </div>
  //       <div class='col-lg-5 col-md-6 col-sm-12 '>
  //        <div class="row p-5 ">
  //        <div class='col-md-11 col-lg-11 col-sm-12 tbl p-6 mt-10 ' style={{backgroundColor:"#f9f9f9",height:"480px"}}>
  //       <div className='row justify-content-center mr-12 '>
  //       {/* <div className='col-lg-12 '> */}
  //       <h2 class='fw-bold text-center mb-4 fs-4 mt-4 text-center ml-12'>Organization Login</h2>

  //       {/* </div> */}
  //    <div className='col-lg-9 mt-4 '>
     
  //    <Form
  //             class=''
  //             name='normal_login'
  //             className='login-form'
  //             initialValues={{
  //               remember: true,
  //             }}
  //             width={80}
  //             onFinish={onFinish}
  //           >
  //             <Form.Item
  //               name='email'
  //               colon={false}
  //               rules={[
  //                 {
  //                   required: true,
  //                   message: 'Please enter Email!',
  //                 },
  //               ]}
  //             >
  //               <Input  className='email-box' style={{ padding: '10px' }} type="email" prefix={<UserOutlined className='site-form-item-icon' />} placeholder='Email' />
  //             </Form.Item>
  //             <Form.Item
  //               name='password'
  //               style={{height:"17px"}}
  //               rules={[
  //                 {
  //                   required: true,
  //                   message: 'Please enter Password!',
  //                 },
  //               ]}
  //             >
  //               <Input.Password className='pwd-box' style={{ padding: '10px' }} prefix={<LockOutlined className='site-form-item-icon' />} type='password' placeholder='Password' />
  //             </Form.Item>
  //             <Form.Item>
  //               {/* <Form.Item name='remember' valuePropName='checked' noStyle>
  //                 <Checkbox>Remember me</Checkbox>
  //               </Form.Item> */}

  //               <a className='login-form-forgot' href=''>
  //                 Forgot password?
  //               </a>
  //             </Form.Item>

  //             <Form.Item>
  //             {/* {success ? <div className='col-lg-4 offset-lg-4'><Spin indicator={antIcon} /></div>: */}
  //             <button type='primary' htmlType='submit' className='btn btn-primary w-100 ' >
  //               {success?<Spin indicator={antIcon} />:"Sign in"}
  //               </button>
                  
                
  //               {/* Or <a href=''>register now!</a> */}
  //             </Form.Item>
              
  //           </Form>
  //           {errorMsg && (
  //             <h4 className='' style={{ color: 'red' }}>
  //               {errorMsg}
  //             </h4>
  //           )}
  //       </div>
       

  //       </div>

  //        </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  //   </>
  // </>
  <div className='bg-light' style={{height:"100vh"}}>
  <AdmnNav/>
  <div className='container-fluid px-3 bg-white'>
      <div className='row '>
      <div className='col-md-7 p-0 d-flex align-items-center justify-start'>  
      <div style={{height:"90%",width:"90%"}}> 
       <img src='/login.jpg' class="" style={{width:"100%",height:"100%"}} />
       </div>
       </div>
      <div className='col-md-4 d-flex align-items-center justify-center flex-column' >
      <div style={{borderRadius:"15px"}} className='p-10 w-100 shadow-lg'> 
      <div className='fw-bold fs-4 col-md-12 mb-4 text-center'>
      Organization Login
      </div>
      <div>
       <Form
            // className=''
            name='normal_login'
            className='login-form w-100'
            initialValues={{
              remember: true,
            }}
            width={80}
            onFinish={onFinish}
          >
            <Form.Item
              name='email'
              colon={false}
              rules={[
                {
                  required: true,
                  message: 'Please enter Email!',
                },
              ]}
            >
              <Input className='email-box' style={{ padding: '10px' }} type="email" prefix={<UserOutlined className='site-form-item-icon' />} placeholder='Email' />
            </Form.Item>
            <Form.Item
              name='password'
              style={{height:"17px"}}
              rules={[
                {
                  required: true,
                  message: 'Please enter Password!',
                },
              ]}
            >
              <Input.Password className='pwd-box' style={{ padding: '10px' }} prefix={<LockOutlined className='site-form-item-icon' />} type='password' placeholder='Password' />
            </Form.Item>
            <Form.Item>
              <a className='login-form-forgot' href=''>
                Forgot password?
              </a>
            </Form.Item>

            <Form.Item>
            <button type='primary' htmlType='submit' className='btn btn-primary w-100 ' >
              {success?<Spin indicator={antIcon} />:"Sign in"}
              </button>
            </Form.Item>
          </Form>
          {errorMsg && (
            <h4 className='' style={{ color: 'red' }}>
              {errorMsg}
            </h4>
          )}
      </div>
      </div>
      </div>

      </div>  
  </div>
  </div>
  );
}

export default OrgSignIn;
